
import { Component, ActionButtonConfig, FormModalMixins } from "@/lib";
import ExportProfit from "@/store/modules/reportstatistics/exportprofit/entity";
@Component
export default class CreateExportProfit extends FormModalMixins {
  model = new ExportProfit();
  created() {
    Object.assign(this.config, { modelTitleL: "app.ExportProfit.RealExchangeRate", labelWidth: 200, okAction: "reportstatistics/exportprofit/create",width:640 });
  }
}
